import { render, staticRenderFns } from "./BackgroundContent.vue?vue&type=template&id=af5ae6ae"
import script from "./BackgroundContent.vue?vue&type=script&lang=js"
export * from "./BackgroundContent.vue?vue&type=script&lang=js"
import style0 from "./BackgroundContent.vue?vue&type=style&index=0&id=af5ae6ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports